(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pivot-cart-drawer__boleta-factura"] && !Shopify.designMode) return;
  try {
    class PivotInvoiceForm extends HTMLElement {
    constructor() {
      super();

      this._state = {
        button: 'save',
        disabledButton: true,
        disabledMainButton: false,
      };

      this.$regionsMapping = JSON.parse(this.querySelector('#pivot-invoice-regions-mapping').textContent);

      this.$rutInput = this.querySelector('input[name="attributes[RUTEmpresa]"]');
      this.$regionSelector = this.querySelector('select[name="attributes[Region]"]');
      this.$communeSelector = this.querySelector('select[name="attributes[Comuna]"]');
      this.$form = this.querySelector('form');
      this.$label = this.querySelector('.cart-discount__label');
      this.$button = this.querySelector('button[type="submit"]');
      this.$clearButton = this.querySelector('#pivot-invoice-clear');
      this.$rutErrorMessage = this.querySelector('.rut-error-message');

      this.initEvents();

      // Verificación inicial del estado del formulario
      this.checkFormState(isInitial);
    }

    onStateChange = () => {
      console.log('Seleccionando el botón apropiado');
      this.$button = this.querySelector('button[type="submit"]');
      this.$clearButton = this.querySelector('#pivot-invoice-clear');
      this.$mainButton = document.querySelector("cart-drawer-component button[type='submit'][name='checkout']");

      this.$button.disabled = this._state.disabledButton;
      this.$clearButton.disabled = this._state.disabledButton;

      this.$mainButton.disabled = this._state.disabledMainButton;

      if (this._state.button === 'save') {
        this.$button.style.display = 'block';
        this.$clearButton.style.display = 'none';
      } else {
        this.$button.style.display = 'none';
        this.$clearButton.style.display = 'block';
      }
    };

    initEvents = () => {
      this.$regionSelector.addEventListener('change', this.handleRegionChange);
      this.$rutInput.addEventListener('keyup', this.handleRutChange);
      this.$rutInput.addEventListener('blur', this.handleRutChange);
      this.$form.addEventListener('submit', this.handleSubmit);
      this.$clearButton.addEventListener('click', this.handleClear);

      this.handleRegionChange();
      this.$communeSelector.value = this.$communeSelector.dataset.value;

      this.$form.addEventListener('change', () => {
        this.checkFormState();
      });
    };

    checkFormState = (isInitial = false) => {
      const $invalid = this.$form.querySelector(':invalid');
      const $inputs = this.$form.querySelectorAll('input, select');
      const allEmpty = Array.from($inputs).every((input) => input.value === '');

      // Cambiar aspecto
      if (allEmpty || !isInitial) {
        this.$clearButton.textContent = 'Guardar';
        this.$clearButton.classList.remove('button-secondary');
      } else {
        this.$clearButton.textContent = 'Limpiar';
        this.$clearButton.classList.add('button-secondary');
      }

      // El botón está habilitado si no hay campos inválidos o si todos están vacíos
      this._state.disabledButton = (!!$invalid && !allEmpty) || isInitial;

      // Si todos los campos están vacíos, el botón debe ser 'limpiar'
      this._state.button = allEmpty ? 'clear' : 'save';

      console.log('Invalid element:', $invalid, 'All empty:', allEmpty);
      this._state.disabledMainButton = !isInitial || !allEmpty || !this._state.disabledButton;
      this.onStateChange();
    };

    handleRegionChange = () => {
      const region = this.$regionSelector.value;
      const communes = this.$regionsMapping[region];
      console.log('Cambio de región', region, communes, this.$communeSelector);
      if (!communes) return;
      this.$communeSelector.innerHTML =
        `<option value="">Selecciona una comuna</option>` +
        communes.map((commune) => `<option value="${commune}">${commune}</option>`).join('');
      // this.$communeSelector.dispatchEvent(new Event('change'));
    };

    handleRutChange = () => {
      console.log('Validando RUT', this.$rutInput.value);
      const $errorMessage = this.querySelector('.rut-error-message');

      if (this.$rutInput.value == '' || validateRut(this.$rutInput.value)) {
        this.$rutInput.setCustomValidity('');
        this.$rutInput.value = formatDNI({ rut: this.$rutInput.value, pais: 'CL' });
        $errorMessage.classList.remove('show');
      } else {
        // this.$rutInput.value = '';
        this.$rutInput.setCustomValidity('Ingresa un RUT válido');
        // Mostrar mensaje de error sin llevar el foco
        $errorMessage.classList.add('show');
      }

      // Actualizar el estado del formulario después de validar el RUT
      this.checkFormState();
    };

    handleSubmit = (e) => {
      e.preventDefault();

      // Verificar si el RUT es válido antes de enviar
      if (this.$rutInput.value && !validateRut(this.$rutInput.value)) {
        this.$rutErrorMessage.classList.add('show');
        return;
      }

      const data = Object.fromEntries(new FormData(e.target));
      console.log('Formulario enviado', data);
      this.$button.disabled = true;
      this.$button.textContent = 'Guardando...';
      this.$clearButton.disabled = true;

      fetch('/cart/update.js', {
        method: 'POST',
        body: new FormData(e.target),
      })
        .then(() => {
          console.log('Carrito actualizado');
          if (data['attributes[RUTEmpresa]'] && data['attributes[RazonSocial]']) {
            this.$label.innerHTML = `<div><span class="pvt-invoicing-label">Factura:</span> ${data['attributes[RazonSocial]']} - ${data['attributes[RUTEmpresa]']}</div>`;
          } else {
            this.$label.textContent = '';
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this._state.button = 'clear';
          this.$button.disabled = false;
          this.$button.textContent = 'Guardar';
          this.$clearButton.disabled = false;
          this._state.disabledMainButton = false;
          this.onStateChange();
        });
    };

    handleClear = () => {
      const attributes = {
        RUTEmpresa: null,
        RazonSocial: null,
        Giro: null,
        DireccionEmpresa: null,
        Region: null,
        Comuna: null,
      };
      // Ocultar mensaje de error al limpiar
      this.$rutErrorMessage.classList.remove('show');
      this.$clearButton.disabled = true;
      this.$clearButton.textContent = 'Limpiando...';
      this.$button.disabled = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({ attributes }),
      })
        .then(() => {
          console.log('Carrito actualizado');
          this.querySelectorAll('input,select').forEach((el) => (el.value = ''));
          this.$label.textContent = '¿Necesitas factura?';
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.$button.disabled = false;
          this.$button.textContent = 'Guardar';
          this.$clearButton.disabled = false;
          this.$clearButton.textContent = 'Limpiar';

          this._state = {
            button: 'save',
            disabledButton: true,
            disabledMainButton: false,
          };

          // Actualizar el estado del formulario después de limpiar
          this.onStateChange();
        });
    };
  }

  if (!customElements.get('pivot-invoice-form')) {
    customElements.define('pivot-invoice-form', PivotInvoiceForm);
  }

  const byCountry = {
    cl: function ({ rut }) {
      const regex = /[^\dkK]/g;

      rut = rut.toString().replace(regex, '');
      const dv = rut.slice(-1).toUpperCase();
      if (rut && dv) {
        rut = rut.slice(0, -1) + '-' + dv;
      }
      return rut;
    },
  };

  function formatDNI({ rut, pais, tipo }) {
    return byCountry[pais?.toLowerCase()]?.({ rut, tipo }) || rut;
  }

  function validateRut(rut) {
    rut = rut.replace(/[^0-9kK]/g, ''); // Eliminar todos los caracteres no numéricos excepto la 'k' o 'K'
    if (rut.length < 8 || rut.length > 9) {
      return false;
    } // El RUT debe tener al menos 2 caracteres (cuerpo + dígito verificador)
    console.log(rut);
    let cuerpo = rut.slice(0, -1); // Obtener el cuerpo del RUT (sin el dígito verificador)
    console.log(cuerpo);
    let dv = rut.slice(-1).toUpperCase(); // Obtener el dígito verificador (puede ser 'k' o 'K' en mayúsculas)

    let suma = cuerpo
      .split('')
      .reverse()
      .reduce((acc, digit, index) => acc + parseInt(digit) * ((index % 6) + 2), 0);

    let resultado = 11 - (suma % 11); // Calcular el dígito verificador esperado
    console.log(resultado);
    let digitoVerificador = resultado === 11 ? '0' : resultado === 10 ? 'K' : resultado.toString();
    console.log(digitoVerificador);
    return dv == digitoVerificador;
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_pivot-header-item"] && !Shopify.designMode) return;
  try {
    let globalMMTimeout = 0;

  class PvtMegamenuItem extends HTMLElement {
    constructor() {
      super();
      this.$detail = this.querySelector('details');
      this.$trigger = this.$detail.querySelector('summary');
      this.$dropdown = this.$detail.querySelector('.pivot-megamenu-item__dropdown');
      this.$aside = this.querySelector('.pivot-megamenu-item__main-aside ul');
      this.$subItemsWrapper = this.querySelector('.pivot-megamenu-item__subitems');
      this.$parent = this.closest('.shopify-section');
      this.openMode = this.dataset.openMode;
      this.sidemenuBehavior = this.dataset.sidemenuBehavior;
      this.isTouch = window.matchMedia('(hover:none)');
      this.hideDebounce = 0;

      // Cerrar el menu al esconder el header
      const observer = new MutationObserver((entries) => {
        entries.forEach((entry) => {
          if (!this.$detail.open) return;
          const clss = this.$parent.getAttribute('class');
          if (clss === entry.oldValue) return;
          this.$detail.open = !this.$parent.classList.contains('shopify-section-header-hidden');
        });
      });
      observer.observe(this.$parent, {
        attributeFilter: ['class'],
        attributes: true,
        attributeOldValue: true,
      });

      // Cerrar al clickear fuera
      this.$dropdown.addEventListener(
        'mouseleave',
        (e) => {
          if (e.target === this.$dropdown) {
            this.$detail.open = false;
          }
        },
        false
      );

      // Hover en los elementos internos
      const openMenu = (e) => {
        e.preventDefault();
        clearTimeout(globalMMTimeout);
        globalMMTimeout = setTimeout(() => {
          const $newMenuActive = this.$aside.querySelector('.pivot-megamenu-item__main-aside-link:hover');
          if (!$newMenuActive) return;

          const $currentMenuActive = this.$aside.querySelector('.active');
          const $currentGridActive = this.$subItemsWrapper.querySelector('.active');

          if ($currentMenuActive) $currentMenuActive.classList.remove('active');
          if ($currentGridActive) $currentGridActive.classList.remove('active');

          $newMenuActive.classList.add('active');
          this.$subItemsWrapper.querySelector(`#${$newMenuActive.dataset.item}`)?.classList.add('active');
        }, 70);
      };
      this.$aside.addEventListener(
        this.sidemenuBehavior === 'navigate' && !this.isTouch.matches ? 'mouseover' : 'click',
        openMenu
      );

      this.$subItemsWrapper.addEventListener('mouseover', () => clearTimeout(globalMMTimeout));
      // Hover en el trigger
      if (this.openMode === 'hover')
        this.$trigger.addEventListener('mouseover', () => {
          this.$detail.open = true;
        });

      // Ocultar al salir del trigger
      this.$trigger.addEventListener('mouseleave', (e) => {
        this.hideDebounce = setTimeout(() => {
          this.$detail.open = false;
        }, 250);
      });
      this.$dropdown.addEventListener('mouseover', () => {
        if (this.hideDebounce) clearTimeout(this.hideDebounce);
      });
    }
  }
  if (!customElements.get('pvt-megamenu-item')) {
    customElements.define('pvt-megamenu-item', PvtMegamenuItem);

    // Abrir/cerrar otros elementos del megamenú
    const stickyHeader = document.querySelector('sticky-header');
    console.log('Cierre atomático details', stickyHeader);
    const summaries = document.querySelectorAll(
      'sticky-header .list-menu--inline > li > header-menu > details, sticky-header .list-menu--inline > li > pvt-megamenu-item > details'
    );

    const openObserver = new MutationObserver((entries) =>
      entries.forEach((entry) => {
        console.log('entry', entry);
        const parentName = entry.target.parentElement.tagName.toLowerCase();
        console.log('ParentName', parentName);
        if (!entry.target.open || (parentName != 'header-menu' && parentName != 'pvt-megamenu-item')) return;
        // console.log('Abrimos', entry.target)
        summaries.forEach((el) => {
          console.log('Elemento', el);
          if (el !== entry.target) el.open = false;
        });
      })
    );

    // Subscribir todos los summaries
    openObserver.observe(stickyHeader, {
      attributes: true,
      attributeFilter: ['open'],
      subtree: true,
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pivot-product-sku"] && !Shopify.designMode) return;
  try {
    class PivotProductSku extends HTMLElement {
    constructor() {
      super();
      this.currentUrl = window.location.href;

      // Inicializar cuando el DOM esté listo
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      // Escuchar por cambios en el historial (cuando se navega entre variantes)
      window.addEventListener('popstate', () => this.handleUrlChange());

      // También observamos cambios en la URL con history.pushState/replaceState
      this.overrideHistoryMethods();
    }

    overrideHistoryMethods() {
      const self = this;
      const originalPushState = history.pushState;
      const originalReplaceState = history.replaceState;

      history.pushState = function () {
        originalPushState.apply(this, arguments);
        self.handleUrlChange();
      };

      history.replaceState = function () {
        originalReplaceState.apply(this, arguments);
        self.handleUrlChange();
      };
    }

    handleUrlChange() {
      if (this.currentUrl !== window.location.href) {
        this.currentUrl = window.location.href;
        this.updateSku();
      }
    }

    updateSku() {
      fetch(window.location.href)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Buscar el elemento con el mismo ID en el nuevo HTML
          const newSkuElement = doc.getElementById(this.id);

          if (newSkuElement && this) {
            this.innerHTML = newSkuElement.innerHTML;
          }
        })
        .catch((error) => {
          console.error('Error al actualizar el SKU:', error);
        });
    }
  }

  // Definir el elemento personalizado
  if (!customElements.get('pivot-product-sku')) {
    customElements.define('pivot-product-sku', PivotProductSku);
  }
  } catch(e) { console.error(e); }
})();

})();
